import * as yup from 'yup';

export const Schema = yup.object({
  percent: yup.number().notRequired(),
  name: yup.string().required(''),
  date_released: yup.string().required(''),
});
